import { cva } from '@vizit/theme';

const containerClasses = cva({
  base: 'flex flex-col gap-4',
});

// Same timing as ScoreStickerCard and the metric cells, so the row settles with them.
const MORPH_TRANSITION = 'transition-[height] duration-350 motion-reduce:transition-none';

// The row itself has no border or background: each cell (and the main score)
// is its own surface with a small shadow, separated by a 4px gap.
//
// The row's height follows the main score card: while the score weights panel is
// closed the card stands taller than the 155px metric cells, which stay vertically
// centered beside it; when the panel opens the row (and card) settle to 155px.
const cardClasses = cva({
  base: `flex items-center gap-2 ${MORPH_TRANSITION}`,
  variants: {
    isProminent: {
      true: 'h-[187px]',
      false: 'h-[155px]',
    },
  },
  defaultVariants: { isProminent: true },
});

// `grid-flow-col auto-cols-fr` gives every metric cell an equal-width 1fr column
// derived from the actual child count, so we don't need to update a hardcoded
// `grid-cols-N` if a metric is added or removed.
const metricsClasses = cva({
  base: 'grid grid-flow-col auto-cols-fr gap-2 flex-1 min-w-0',
});

// The score weights panel slides open beneath the row on the same timing, so the row
// shrinking and the panel growing read as one motion. Animating the grid row from 0fr
// to 1fr lets the panel grow to its natural height without measuring it.
const drawerClasses = cva({
  base: 'grid transition-[grid-template-rows] duration-350 motion-reduce:transition-none',
  variants: {
    isOpen: {
      true: 'grid-rows-[1fr]',
      false: 'grid-rows-[0fr]',
    },
  },
});

// `min-h-0` lets the row collapse below the panel's height. The gap above the panel lives on a
// wrapper inside this clipped child, not on it: a border box can't shrink below its own padding,
// so padding here would leave a strip showing under the cards while the drawer is closed.
const drawerContentClasses = cva({
  base: 'min-h-0 overflow-hidden transition-opacity duration-350 motion-reduce:transition-none',
  variants: {
    isOpen: {
      true: 'opacity-100',
      false: 'opacity-0',
    },
  },
});

export { cardClasses, containerClasses, drawerClasses, drawerContentClasses, metricsClasses };
